$(function () {
  var $faqItems = $('.blue-faq .faqs > div');

  function toggleFaq($faqItem) {
    var isOpen = $faqItem.hasClass('active');
    var $answer = $faqItem.children('p');

    $faqItem
      .toggleClass('active', !isOpen)
      .attr('aria-expanded', String(!isOpen));

    $answer
      .stop(true, true)
      .slideToggle(200)
      .attr('aria-hidden', String(isOpen));
  }

  $faqItems.on('click', function (event) {
    if ($(event.target).closest('a').length > 0) {
      return;
    }

    toggleFaq($(this));
  });

  $faqItems.on('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    toggleFaq($(this));
  });
});
